import { SVGProps, Ref, forwardRef } from 'react';

export const SmartphoneOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.8 8c0-1.736.065-2.968.235-3.87.166-.884.402-1.272.613-1.482s.598-.447 1.482-.614c.902-.17 2.134-.234 3.87-.234s2.968.065 3.87.234c.884.167 1.272.403 1.482.614s.447.598.613 1.482c.17.902.235 2.134.235 3.87v8c0 1.736-.065 2.968-.235 3.87-.166.884-.402 1.272-.613 1.482s-.598.447-1.482.613c-.902.17-2.134.235-3.87.235s-2.968-.065-3.87-.235c-.884-.166-1.272-.402-1.482-.613s-.447-.598-.613-1.482c-.17-.902-.235-2.134-.235-3.87zM4 8c0-7 1-8 8-8s8 1 8 8v8c0 7-1 8-8 8s-8-1-8-8zm5.5-3.9v1.8h5V4.1z"
                fill="currentColor"
            />
        </g>
    </svg>
));
SmartphoneOutlinedSize24Glyph.displayName = 'SmartphoneOutlinedSize24Glyph';
